<template>
  <div class="programs-header">
    <h2 class="programs-header__title">
      <i class="programs-header__title__icon icon-document" />
      <app-i18n code="entities.program.label.many" />
    </h2>
    
    <el-row
      v-if="tabs && !!tabs.length"
      type="flex"
      align="left"
      class="programs-header__tabs"
    >
      <div class="programs-header__tabs__container">
        <el-button-group>
          <el-button
            v-for="(tab, i) in allTabs"
            :key="`programs-header__tabs__tab--${i}`"
            class="programs-header__tabs__tab"
            :class="{ 'programs-header__tabs__tab--active': i === activeTabIndex }"
            @click="onTabClick(i)"
          >
            <app-i18n :code="`enumerators.programType.${tab}`" />
          </el-button>
        </el-button-group> 
      </div>
    </el-row>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'programs-header',
  props: {
    tabs: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      activeTabIndex: 0
    }
  },
  computed: {
    allTabs() {
      return ['all', ...this.tabs]
    }
  },
  methods: {
    ...mapMutations({
      setVisibleProgramsType: 'setVisibleProgramsType'
    }),

    onTabClick(index) {
      this.activeTabIndex = index

      const type = this.tabs[index - 1]
      this.setVisibleProgramsType({ type })
    }
  },
}
</script>

<style lang="scss" scoped>
.programs-header {
  --mobile-header-padding: 24px;
  
  position: relative;
  z-index: 0;
  background: #ffffff;
  padding: 50px 0 0;

  &__title {
    @include layout-container;

    font-size: 22px;
    font-weight: 500;
    font-style: normal;
    color: #4c4c4c;
    text-transform: uppercase;
    padding-left: var(--mobile-header-padding);

    &__icon {
      margin-right: 10px;
      font-size: 20px;
    }
  }

  &__tabs {
    margin-top: 30px;
    border-bottom: 2px solid #c5c5c570;

    &__container {
      @include layout-container;
    }
  }

  &__tabs,
  &__tabs .el-button-group,
  &__tabs .el-button-group .el-button {
    height: 70px;
    border-radius: 0;
  }

  &__tabs__tab {
    min-width: 80px;
    padding: 15px 0;
    text-align: center;
    border: 0;
    border-bottom: 3px solid transparent;
    transition: color .3s ease-in;
    transition: border-color .5s ease-in;
    background-color: transparent;

    span {
      font-size: 18px;
      font-weight: 300;
      letter-spacing: -0.4px;
      color: #404040;
      text-transform: none;
    }
  }

  &__tabs__tab:active,
  &__tabs__tab:visited,
  &__tabs__tab:focus {
    background-color: transparent;
    color: #2acccc;
    border-color: #2acccc;
  }

  &__tabs__tab:hover {
    background-color: transparent;
    color: #2acccc;
    border-bottom: 3px solid transparent;
  }

  &__tabs__tab--active,
  &__tabs__tab--active:hover {
    color: #2acccc;
    border-color: #2acccc;
  }

  &__subheader {
    height: 85px;
    border-bottom: 2px solid #f7f7f7;
  }

  &__subtitle {
    @include layout-container;

    display: flex;
    align-items: center;
    padding-left: var(--mobile-header-padding);

    span {
      margin-right: 5px;
      font-size: 22px;
      font-weight: 500;
      font-style: normal;
      color: #4c4c4c;
    }
  }
}
</style>
